import { tv } from 'tailwind-variants'

export const buttonIcon = tv({
  base: 'flex h-10 w-10 items-center justify-center hover:opacity-70 active:opacity-70 web:transition web:duration-300',
  variants: {
    isFocusVisible: {
      true: 'outline outline-2 outline-blue-sky',
    },
  },
  defaultVariants: {
    isFocusVisible: false,
  },
})
